



































































































































































































































































































import { Vue, Component } from 'vue-property-decorator';
import { VbSnackbarService } from 'bag-of-holding-library';
import _ from 'lodash';
import DrdService from '@/domain/drd-2.0/service/drd.service';
import Drd from '@/domain/drd-2.0/entity/drd.entity';
import Loading from '@/shared/loading/loading.component.vue';
import KeyAreaSkill from '@/domain/drd-2.0/entity/key-area-skill.entity';
import GoalAchievementTypes from '@/views/drd/form/tabs/indicators/goal-achievement-types.json';
import GoalMaskTypes from '@/views/drd/form/tabs/indicators/goal-mask-types';
import UtilityTypes from '@/views/drd/form/tabs/indicators/utility-types.json';
import ScrollToTop from '@/shared/scroll-to-top.component.vue';
import WeightCategories from '@/views/drd/form/tabs/indicators/weight-categories.json';
import ReadDrdPanel from './components/read/read-drd-panel.component.vue';
import ReadDrdCaptions from './components/read/read-drd-captions.component.vue';
import SkillTypes from './skill/skill-types.json';
import ReadDrdCaptionInterface from './components/read/read-drd-caption.interface';
import ReadDrdCaption from './components/read/read-drd-caption.component.vue';

const PRINT_DELAY_MS = 500;

@Component({
  components: {
    Loading,
    ReadDrdCaptions,
    ReadDrdPanel,
    ScrollToTop,
    ReadDrdCaption,
  },
})
export default class ReadDrdView extends Vue {
  drd: Drd = new Drd();

  loading: boolean = false;

  collapsedAll: boolean = false;

  private getData() {
    this.loading = true;
    DrdService.getByAssignmentId(this.$route.params.id)
      .then((data) => {
        this.drd = data;
      }).catch((error) => {
        VbSnackbarService.showError(error.response.data.messages.toString());
      }).finally(() => {
        this.loading = false;
      });
  }

  handleCollapseAll(): void {
    if (this.collapsedAll) {
      this.expandAll();
      return;
    }
    this.collapseAll();
  }

  collapseAll(): void {
    this.collapsedAll = true;
    const { collapsableKeyAreas }: any = this.$refs;
    const { collapsableIndicators }: any = this.$refs;
    const { collapsableSkills }: any = this.$refs;
    collapsableKeyAreas.forEach(it => it.collapse());
    collapsableIndicators.collapse();
    collapsableSkills.forEach(it => it.collapse());
  }

  expandAll(): void {
    this.collapsedAll = false;
    const { collapsableKeyAreas }: any = this.$refs;
    const { collapsableIndicators }: any = this.$refs;
    const { collapsableSkills }: any = this.$refs;
    collapsableKeyAreas.forEach(it => it.expand());
    collapsableIndicators.expand();
    collapsableSkills.forEach(it => it.expand());
  }

  getSkillDescription(type: String): String {
    const foundType = SkillTypes.find((it: any) => it.value === type);
    return foundType
      ? foundType.description
      : type;
  }

  get groupSkillsByType(): Map<String, KeyAreaSkill[]> {
    const result = _.groupBy(
      this.drd.skills,
      (keyAreaSkill: KeyAreaSkill) => keyAreaSkill.skill.type,
    );
    return new Map<String, KeyAreaSkill[]>(Object.entries(result));
  }

  formatGoalAchievementType(achievementType: string): string {
    if (!achievementType) return '';
    const type = GoalAchievementTypes.find(it => it.value === achievementType);
    return type ? type.text : achievementType;
  }

  formatGoalValue(goalValue: number, goalMaskType: string): string | number {
    if (!goalMaskType) return goalValue;
    const formatter = GoalMaskTypes.find(it => it.value === goalMaskType);
    return formatter && goalValue ? formatter.format(goalValue) : goalValue;
  }

  formatUtility(utilityType: string): string {
    if (!utilityType) return '';
    const category = UtilityTypes.find(it => it.value === utilityType);
    return category ? category.text : utilityType;
  }

  formatWeight(weight: string): string {
    if (!weight) return '';
    const weightCategory = WeightCategories.find(it => it.value === weight);
    return weightCategory ? weightCategory.text : weight;
  }

  formatGoalMaskType(goalMask: string): string {
    if (!goalMask) return '';
    const goalMaskType = GoalMaskTypes.find(it => it.value === goalMask);
    return goalMaskType ? goalMaskType.text : goalMask;
  }

  formatExpectedOrRecommended(expected: number): string | number {
    if (expected === 0) return 'R';
    if (expected === 1) return 'E';
    return expected;
  }

  formatExpected(skillTypeKey: String, expected: number): string | number {
    if (!skillTypeKey) return expected;
    const skillType = SkillTypes.find(it => it.value === skillTypeKey);
    if (!skillType) return expected;
    if (!skillType.isBoolean) {
      return expected - skillType.decrementValue!!;
    }
    return this.formatExpectedOrRecommended(expected);
  }

  private windowPrint() {
    const originalTitle = document.title;
    const formatterAssignment = this.drd.assignmentDescription.replace(/ /g, '_');
    document.title = `DRD_${formatterAssignment}`;
    window.print();
    document.title = originalTitle;
  }

  private async handleKeydown(e) {
    if ((e.ctrlKey || e.metaKey) && e.key === 'p') {
      e.preventDefault();
      this.expandAll();
      await new Promise(resolve => setTimeout(resolve, PRINT_DELAY_MS));
      this.windowPrint();
    }
  }

  print(): void {
    this.expandAll();
    setTimeout(() => {
      this.windowPrint();
    }, PRINT_DELAY_MS);
  }

  get currentYear(): number {
    return new Date().getFullYear();
  }

  get getAllSkills(): KeyAreaSkill[] {
    return this.drd.keyAreasActive.flatMap(it => it.skillsActive);
  }

  skillLevels: ReadDrdCaptionInterface[] = this.buildOptionsBySkillType('SKILL');

  buildOptionsBySkillType(skillType: string) {
    return SkillTypes
      .filter(type => type.value === skillType)[0]
      .options.filter(option => option.isSelected)
      .map(option => ({
        title: `${option.value - 1} (${option.name})`,
        description: option.details,
      }));
  }

  mounted() {
    window.addEventListener('keydown', this.handleKeydown);
  }

  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeydown);
  }

  created() {
    this.getData();
  }
}
